module.exports = __webpack_public_path__ + "img/ListChecks@1x.90d8fa27.svg";